import { Component, inject, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-modal',
    standalone: true,
    imports: [TranslocoModule],
    templateUrl: './error-modal.component.html',
    styleUrl: './error-modal.component.scss',
})
export class ErrorModalComponent {

    @Input() message?: string;

    protected readonly activeModal = inject(NgbActiveModal);

}
